import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const UpdateIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 20 20">
            <path
                d="M17.5 4V9H12.5"
                stroke="#06BD0E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M15.6171 12.3318C15.1295 13.7629 14.2065 14.9908 12.9872 15.8307C11.7679 16.6705 10.3184 17.0767 8.85707 16.988C7.39575 16.8994 6.0018 16.3207 4.88528 15.3392C3.76875 14.3577 2.99015 13.0265 2.66679 11.5463C2.34343 10.0661 2.49284 8.51697 3.0925 7.13243C3.69216 5.74789 4.70958 4.60294 5.99145 3.8701C7.27332 3.13726 8.75018 2.85624 10.1995 3.06938C11.6488 3.28253 12.9921 3.97829 14.0268 5.05182L17.5 8.44293"
                stroke="#06BD0E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
};
